import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader */

import firebaseConfig from './config/firebase.js'
import firebase from 'firebase'
import "firebase/auth"
import "firebase/firestore"
//localize filter
import localizeFilter from './filters/localize.filter'

const fb = firebase.initializeApp(firebaseConfig)//

Vue.$db = fb.firestore()
Vue.filter('localize', localizeFilter)

const opts = {
	icons: {
		iconfont: 'mdi', // default - only for display purposes
	},
	theme: {
		themes: {
			light: {
				primary: '#607D8B',//blu-grey
				secondary: '#1A237E',//indigo darken-4
				accent: '#CDDC39',//lime
				error: '#BF360C',//deep-orange
			},
		},
	}
}
Vue.use(Vuetify)

Vue.config.productionTip = false

new Vue({
	vuetify: new Vuetify(opts),
	router,
	store,
	render: h => h(App)
}).$mount('#app')
